<div class="main-table" *ngIf="isExist(overlayTypologyLabels)">
    <label>Overlay/Typology </label>
    <div class="content" *ngFor="let overlayTypology of overlayTypologyLabels | keyvalue">
        <div class="table">
            <div class="column-title">
                <div class="table-row" *ngFor="let row of overlayTypologyRow; first as isFirst">
                    <div [class.first-table-row]="isFirst">{{row}}</div>
                </div>
            </div>
            <div class="table-body">
                <div *ngFor="let field of overlayTypology.value" class="table-row">
                    <div class="fixed-width-field"> {{field?.Name}}</div>
                    <div> {{getTypeNameById(overlayTypology.key)}} </div>
                    <div> {{getCalibrationStatusType(field?.diffStatus)}} </div>
                </div>
            </div>
        </div>
    </div>
</div>
